// extracted by mini-css-extract-plugin
module.exports =  {"toggleButton":"jut__LanguageSelector__toggleButton","hideDropdownIndicator":"jut__LanguageSelector__hideDropdownIndicator"};